import React from "react";
import { Box, Card, Chip, Stack, Typography } from "@mui/material";
import styles from "./cisoDashboard.module.scss";

const techniques = [
  {
    id: "T1566",
    name: "Phishing",
    tag: "High",
    score: 47,
    bg: "rgba(245, 158, 11, 0.1)",
    color: "rgba(245, 158, 11, 1)",
  },
  {
    id: "T1190",
    name: "Exploit Public App",
    tag: "Critical",
    score: 33,
    color: "rgba(239, 68, 68, 1)",
    bg: "rgba(239, 68, 68, 0.1)",
  },
  {
    id: "T1078",
    name: "Valid Accounts",
    tag: "Medium",
    score: 24,
    color: "rgba(5, 117, 230, 1)",
    bg: "rgba(5, 117, 230, 0.1)",
  },
  {
    id: "T1059",
    name: "Command Execution",
    tag: "High",
    bg: "rgba(245, 158, 11, 0.1)",
    score: 42,
    color: "#f59e0b",
  },
  {
    id: "T1082",
    name: "System Discovery",
    tag: "Low",
    score: 47,
    bg: "rgba(20, 184, 166, 0.1)",
    color: "rgba(20, 184, 166, 1)",
  },
];

export const MitreTechniquesCard = ({ handleNavigate }) => {
  return (
    <Card sx={{ borderRadius: "12px", p: 2 }} variant="outlined" elevation={0}>
      <Box display="flex" alignItems="center" gap={1} mb={1}>
        <Typography fontWeight={700}>MITRE ATT&CK Techniques</Typography>
      </Box>
      <Box>
        {techniques.map((tech) => (
          <Box key={tech.id} mb={1}>
            <Stack
              gap={2}
              direction="row"
              sx={{
                cursor: "pointer",
                color: "#4a5565",
                transition: "color 0.2s ease",
              }}
              onClick={() => handleNavigate("phishing-events")}
            >
              <Typography
                fontWeight={600}
                color={"rgba(74, 85, 101, 1)"}
                sx={{
                  "&:hover": {
                    color: "#0575E6",
                  },
                }}
              >
                {tech.id} – {tech.name}
              </Typography>
              <Box className={styles.badgeRow}>
                <Chip
                  size="small"
                  label={tech.tag}
                  sx={{
                    background: tech.bg,
                    color: `${tech.color} !important`,
                    "&:hover": {
                      color: tech.color,
                    },
                  }}
                />
              </Box>
            </Stack>
            <Stack gap={2} direction="row" mt={0.5} alignItems="center">
              <Box flex="1">
                <Box className={styles.progressBar}>
                  <Box
                    className={styles.progressFill}
                    style={{ width: `${tech.score}%`, background: tech.color }}
                  />
                </Box>
              </Box>
              <Typography fontWeight={600}>{tech.score}</Typography>
            </Stack>
          </Box>
        ))}
      </Box>
    </Card>
  );
};

export default MitreTechniquesCard;
